<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.identificacao="{ item }">
				<identificacao-ampla-cota :item="item" tamanho-icone="21"></identificacao-ampla-cota>
			</template>
			<template #item.tipo="{ item }">
				<texto-tooltip :texto="item.tipo" :tamanho-maximo="textoTamanhoMaximo.tipo"></texto-tooltip>
			</template>
			<template #item.seq="{ item }">
				<span> {{ item.sequencia }} </span>
			</template>
			<template #item.descricao="{ item }">
				<texto-tooltip :texto="item.descricao" :tamanho-maximo="textoTamanhoMaximo.descricao"></texto-tooltip>
			</template>
			<template #item.fornecedor="{ item }" v-if="!informacoesPedido.fornecedorUnicoDaAta">
				<texto-tooltip :texto="item.fornecedor" :tamanho-maximo="textoTamanhoMaximo.fornecedor"></texto-tooltip>
			</template>
			<template #item.marca="{ item }">
				<texto-tooltip :texto="item.marca" :tamanho-maximo="textoTamanhoMaximo.marca"></texto-tooltip>
			</template>
			<template #item.unidadeAquisicao="{ item }">
				<texto-tooltip
					:texto="item.unidadeAquisicao"
					:tamanho-maximo="textoTamanhoMaximo.unidadeAquisicao"
				></texto-tooltip>
			</template>
			<template #item.unidadeDespesa="{ item }">
				<span>{{ item.unidadeDespesa }}</span>
			</template>
			<template #item.saldoAta="{ item }">
				<span> {{ item.saldoAta | rpCurrencyFilter('', numeroCasasDecimaisQtde) }} </span>
			</template>
			<template #item.saldoOrgao="{ item }">
				<span> {{ formatarSaldoOrgaoComFiltro(item) }} </span>
			</template>
			<template #item.quantidadeSolicitada="{ item }">
				<az-money
					v-model="item._quantidadeSolicitada"
					:name="`Quantidade-${item.id}`"
					:precision="numeroCasasDecimaisQtde"
					prefix=""
					class="cell-editable"
					dense
					@input="$emit('salvar-item', item)"
					v-az-auth="permissoes.pedidoUtilizacaoItemQtdSolicitadaEditar"
				></az-money>
			</template>
			<template #item.valorUnitario="{ item }">
				<span> {{ item.valorUnitario | azCurrency(numeroCasasDecimaisValores) }} </span>
			</template>
			<template #item.valorTotalItemAta="{ item }">
				<span> {{ item.valorTotalItemAta }}</span>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
	</div>
</template>
<script>
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import { mapState } from 'vuex'
import rpCurrencyFilter from '@/views/filters/rp-currency-filter'
import IdentificacaoAmplaCota from '@/views/components/IdentificacaoAmplaCota.vue'

export default {
	name: 'selecao-itens-pedido-listagem',
	components: { IdentificacaoAmplaCota },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	emits: ['salvar-item'],
	data() {
		return {
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item de ata para adicionar por aqui',
			},
			paginacaoInterna: this.paginacao,
			textoTamanhoMaximo: {
				tipo: 25,
				codigo: 25,
				descricao: 25,
				marca: 25,
				unidadeAquisicao: 25,
				fornecedor: 25,
			},
		}
	},
	computed: {
		...mapState({
			informacoesPedido: (state) => state.pedido.informacoesPedido,
		}),
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisQtde
			},
		},
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisValores
			},
		},
		colunas() {
			return this.getColunasTabela(this.informacoesPedido)
		},
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		getColunasTabela(informacoesPedido) {
			const colunas = []

			colunas.push(new TabelaColunaUtils('', 'identificacao', '1%'))
			colunas.push(new TabelaColunaUtils('Tipo', 'tipo', '8%'))
			colunas.push(new TabelaColunaUtils('Seq', 'sequencia', '3%'))
			colunas.push(new TabelaColunaUtils('Descrição', 'descricao', '15%'))

			if (informacoesPedido && !informacoesPedido.fornecedorUnicoDaAta) {
				colunas.push(new TabelaColunaUtils('Fornecedor', 'fornecedor', '8%'))
			}

			colunas.push(new TabelaColunaUtils('Marca', 'marca', '8%'))
			colunas.push(new TabelaColunaUtils('Unid. Aquis.', 'unidadeAquisicao', '5%'))
			colunas.push(new TabelaColunaUtils('Item Despesa', 'unidadeDespesa', '5%'))
			colunas.push(new TabelaColunaUtils('Saldo Ata', 'saldoAta', '8%'))
			colunas.push(new TabelaColunaUtils('Saldo Órgão', 'saldoOrgao', '8%'))
			colunas.push(new TabelaColunaUtils('Qtde. Solicitada', 'quantidadeSolicitada', '8%'))
			colunas.push(new TabelaColunaUtils('Valor Unitário', 'valorUnitario', '8%'))
			colunas.push(new TabelaColunaUtils('Valor Total', 'valorTotalItemAta', '10%'))

			return colunas
		},
		formatarSaldoOrgaoComFiltro(item) {
			if (item.atendeRegrasDivisaoCotaConsumo && item.orgaoPossuiSaldo && item.saldoOrgao === 0) return '--'

			return rpCurrencyFilter(item.saldoOrgao, '', this.numeroCasasDecimaisQtde)
		},
	},
}
</script>
